import { useState, useRef } from 'react';

export default function Tooltip({ text, size = "default" }) {
    const [showTooltip, setShowTooltip] = useState(false);
    const [position, setPosition] = useState({ x: 0, y: 0 });
    const hideTimeout = useRef(null);

    // Size styles
    const iconSize = size === "small" ? 16 : 24;
    const fontSize = size === "small" ? 10 : 14;

    const handleMouseEnter = (e) => {
        if (hideTimeout.current) clearTimeout(hideTimeout.current);

        // Capture mouse position with offset
        setPosition({ x: e.clientX + 10, y: e.clientY - 30 });
        setShowTooltip(true);
    };

    const handleMouseLeave = () => {
        // Delay hiding tooltip to allow hover into tooltip content
        hideTimeout.current = setTimeout(() => {
            setShowTooltip(false);
        }, 150); // 150ms delay, adjust as needed
    };

    return (
        <>
            {/* Info Icon */}
            <div
                style={{
                    position: 'relative',
                    background: '#007bff',
                    color: 'white',
                    width: `${iconSize}px`,
                    height: `${iconSize}px`,
                    borderRadius: '50%',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    fontSize: `${fontSize}px`,
                    cursor: 'pointer',
                    marginLeft: '4px',
                }}
                onMouseEnter={handleMouseEnter}
                onMouseLeave={handleMouseLeave}
            >
                i
            </div>

            {/* Tooltip Content */}
            {showTooltip && (
                <div
                    className="map-tooltip"
                    style={{
                        position: 'fixed',
                        top: `${position.y}px`,
                        left: `${position.x}px`,
                        background: 'white',
                        padding: '6px 10px',
                        borderRadius: '4px',
                        fontSize: '12px',
                        boxShadow: '0 1px 4px rgba(0,0,0,0.3)',
                        color: 'black',
                        maxWidth: '300px',
                        minWidth: '150px',
                        lineHeight: '1.4',
                        zIndex: 2000,
                        fontWeight: 'normal',
                    }}
                    onMouseEnter={() => {
                        if (hideTimeout.current) clearTimeout(hideTimeout.current);
                        setShowTooltip(true);
                    }}
                    onMouseLeave={() => setShowTooltip(false)}
                    dangerouslySetInnerHTML={{ __html: text }}
                >
                </div>
            )}
        </>
    );
}
